const {Vue, jQuery: $} = window;

import {store, store$} from "../_config-store";
import {
	getRegionDir,
	convertName
} from "../_utilities";

const truckModel$ = store$
	.map(state => state.truckModel);

const viewOptions$ = store$
	.map(state => state.viewOptions);

const viewOption$ = store$
	.map(state => state.viewOption);

const activeOption$ = store$
	.map(state => state.activeOption);

const focusedOption$ = store$
	.map(state => state.focusedOption);

export const options = {
	template:
	`<transition-group name="fade" tag="div" id="misc-overlay" v-if="viewOptionId === 'misc'">
		<figure v-for="option in activeOptions" v-bind:key="optionClass(option) + optionClass(focusedOption)" v-bind:class="optionClass(option)" v-bind:focused="optionClass(focusedOption)" v-bind:style="{backgroundImage:iconUrl(option,focusedOption)}"></figure>
	</transition-group>`,
	subscriptions: function() {
		return {
			viewOption: viewOption$,
			viewOptions: viewOptions$,
			truckModel: truckModel$,
			activeOption: activeOption$,
			focusedOption: focusedOption$,
		}
	},
	computed: {
		viewOptionId: function(){
			return this.viewOptions[_.findIndex(this.viewOptions,{name: this.viewOption})].id;
		},
		activeOptions: function(){
			return this.activeOption ? [this.activeOption] : ['none'];
		},
		
	},
	methods: {
		iconUrl(option,focusedOption){
			let {mediaHostAddress} = window;
            return option && focusedOption ? 'url('+(mediaHostAddress || '') + "/images/region/" + getRegionDir() + '/options/' + convertName(this.truckModel) + '/' +  this.optionClass(option) + '-' + this.optionClass(focusedOption) + ".jpg?auto=format%2Ccompress&fm=jp2%2Cpng" + ')' : false;
		},
		optionClass: function(optionLabel = ''){
			return _.kebabCase(optionLabel.replace('™',''));
		}
	}
}


Vue.component('misc-overlay',options);